import packageJson from '../../package.json';
const url = 'https://api-dev.pegasimed.com';
const ftp = 'https://api-dev.pegasimed.com';
export const environment = {
  VERSION: packageJson.version,
  production: true,
  url: url,
  type: 'DEV',
  assetsBucket: 'devassets-pegasi',
  socketVideoEndpoint: 'https://api-dev.pegasimed.com',
  socketVideoEndpointURI: '/video-chat',
  videoChatVendor: 'aws',
  credentials: {
    videoChat: {
      user: 'pegasi-med-cloud-app-videochat',
      pwd: 'LQ!J?@q2u`c+>'
    },
    oauth: {
      user: 'pegasi-med-cloud-app-videochat',
      pwd: 'LQ!J?@q2u`c+>'
    }
  },
  yandexApi:
    'https://translate.yandex.net/api/v1.5/tr.json/translate?key=trnsl.1.1.20200225T212751Z.f43be781ae4fc024.9ae8eca03f756616d3e8fc5957dcd62e428319f8&text=',
  appointment: url + '/schedules/appointments/',
  appointmentTypes: url + '/enumerables/appointmentTypes/',
  banks: url + '/enumerables/banks/',
  backgroundType: url + '/clinicTables/backgroundTypes/',
  countries: url + '/enumerables/countries/',
  civilStatus: url + '/enumerables/maritalStatus/',
  consultationReason: url + '/clinicTables/consultationReasons/',
  customerOrganization: url + '/customerOrganizations/',
  functionalExam: url + '/clinicTables/functionalExamTypes/',
  gender: url + '/enumerables/genders/',
  handDominance: url + '/enumerables/handDominances/',
  hummanBodySystem: url + '/enumerables/humanBodySystems/',
  identificationType: url + '/enumerables/identifierTypes/',
  languages: url + '/enumerables/languages/',
  login: url + '/auth/login',
  medicalIdentificationType: url + '/enumerables/medicalIdentifications/',
  nationality: url + '/enumerables/nationalities/',
  organizationCharts: url + '/organizationalCharts/',
  organizationalChartAdministrativeAttribute: url + '/enumerables/organizationalChartAdministrativeAttributes/',
  organizationalChartAttribute: url + '/enumerables/organizationalChartAttributes/',
  technicUsers: url + '/technicUsers/',
  specialtiesSystem: url + '/enumerables/systemSpecialties/',
  procedureTypes: url + '/procedureTypes/',
  specialties: url + '/enumerables/clinicalSpecialties/',
  contactRelationships: url + '/enumerables/contactRelationships/',
  qualifications: url + '/enumerables/qualificationTypes/',
  practitioners: url + '/practitioners/',
  typePerson: url + '/enumerables/personTypes/',
  laboratoryVariables: url + '/clinicTables/laboratoryVariables/',
  shifts: url + '/schedules/shifts/',
  updateSubType: '/updateSubtype/',
  deleteSubType: '/deleteSubtype/',
  addSubType: '/addSubtype/',
  bodyRegions: url + '/clinicTables/bodyRegions/',
  addVariable: '/addVariable/',
  removeAllVariable: '/removeVariables/',
  deleteVariable: '/deleteVariable/',
  updateVariable: '/updateVariable/',
  diagnosticType: url + '/clinicTables/diagnostics/',
  specificExam: url + '/clinicTables/specificExamTypes/',
  systemSpecialties: url + '/enumerables/systemSpecialties/',
  paraclinicalExam: url + '/clinicTables/paraclinicalExamTypes/',
  habitType: url + '/clinicTables/habitTypes/',
  profession: url + '/enumerables/professions/',
  users: url + '/users/',
  patients: url + '/patients/',
  scheduleProfile: url + '/schedules/profiles/',
  procedurePlace: url + '/schedules/locations/',
  procedurePlaceBinnacle: url + '/schedules/locationLogs/',
  organizationChartsPlaces: url + '/schedules/locations/organizationalCharts/',
  relationshipTypes: url + '/enumerables/personTypes/',
  turns: url + '/schedules/shifts/',
  reception: url + '/schedules/receptions/',
  treatmentType: url + '/clinicTables/treatmentTypes/',
  prescription: url + '/prescriptions/',
  medications: url + '/medications/',
  practitionerUser: url + '/practitionerUsers/',
  admonUser: url + '/administrativeUsers/',
  thecnicalUser: url + '/technicUsers/',
  medicines: url + '/medications/',
  genericMedication: url + '/enumerables/genericMedicationComponents/',
  medicationForm: url + '/enumerables/medicationForms/',
  ingredientType: url + '/enumerables/ingredientTypes/',
  unitType: url + '/enumerables/unitTypes/',
  unitMass: url + '/enumerables/massUnits/',
  unitVolume: url + '/enumerables/volumeUnits/',
  episodes: url + '/encounters/',
  evolutions: url + '/evolutions/',
  orders: url + '/medicalOrders/serviceRequests/',
  scheduleProcedure: url + '/schedules/procedures/',
  procedureState: url + '/enumerables/typeProcedureStatus/',
  practitionerRole: url + '/enumerables/typeProcedureRoles/',
  patientProfile: url + '/patientProfiles/',
  familyRelationShip: url + '/enumerables/familyRelationShips/',
  lengthUnit: url + '/enumerables/lengthUnits/',
  diagnosisTypes: url + '/enumerables/diagnosisTypes/',
  conditionVerificationStatus: url + '/enumerables/conditionVerificationStatus/',
  treatmentTypes: url + '/clinicTables/treatmentTypes/',
  episodeReports: url + '/episodeReports/',
  allReports: url + '/reports/',
  reportPatien: url + '/reports/patients/',
  reportsBlank: url + '/blankReports/',
  egressReport: url + '/egressReports/',
  customReport: url + '/customReports/',
  payerTypes: url + '/enumerables/payerTypes/',
  globalSettings: url + '/globalSettings/',
  weightUnits: url + '/enumerables/weightUnits/',
  timeUnits: url + '/enumerables/timeUnits/',
  timeZone: url + '/enumerables/timeZones/',
  acelerationUnits: url + '/enumerables/accelerationUnits/',
  frequencyUnits: url + '/enumerables/frequencyUnits/',
  speedUnits: url + '/enumerables/speedUnits/',
  pressureUnits: url + '/enumerables/pressureUnits/',
  currenciesUnit: url + '/enumerables/currencies/',
  actPriorities: url + '/enumerables/actPriorities/',
  globalCore: url + '/patientConfigs/',
  reportConfig: url + '/reportConfigs/',
  timeLines: url + '/timeLines/',
  checkMedic: 'checkMedicationAllergiesByPatient/',
  allergyIntolerance: '/allergyIntolerances/',
  substance: url + '/enumerables/substances/',
  manifestation: url + '/enumerables/allergyClinicalFindings/',
  clinicalStatus: url + '/enumerables/allergyIntoleranceStatus/',
  validateMedicines: 'validate/',
  configParaclinicalExams: url + '/paraclinicalExams/examOrderConfigs/',
  clinicalLaboratory: url + '/paraclinicalExams/clinicalLaboratories/',
  patologicalAnatomy: url + '/paraclinicalExams/pathologicalAnatomies/',
  examOrder: url + '/paraclinicalExams/examOrders/',
  imageUrl: url + '/paraclinicalExams/imaging/',
  statitics: url + '/statistics/',
  patientStatistics: url + '/patientStatistics/',
  reportStatitics: url + '/statistics/CSV',
  endpoint: url,
  appointmentAndProcedure: url + '/schedules/integrations/',
  paraclinicalExams: url + '/paraclinicalExams/',
  forgotPass: url + '/auth/forgotPassword/',
  activateUser: url + '/auth/activateNewUser/',
  recoveryPass: url + '/auth/resetPassword/',
  resendActivationEmail: url + '/users/resendActivationEmail/',
  patientPaginate: url + '/patients/paginate/',
  logOut: url + '/auth/logout/',
  updateFirstLogin: url + '/auth/updateFirstLogin/',
  getRoles: url + '/roles/',
  customizeReport: url + '/customReportTypes/',
  customReports: url + '/customReports/',
  prescriptionConf: url + '/prescriptionConfigs/',
  configEpisodes: url + '/episodeConfigs/',
  evolutionsInform: url + '/evolutionReports/',
  imagenologyStudies: url + '/clinicTables/imagenologyStudiesTypes/',
  patientsFiles: url + '/patientFiles/uploads/',
  ftp: ftp + '/patientFiles/',
  pathologicalSampleTypes: url + '/clinicTables/pathologicalSampleTypes/',
  warnings: url + '/patientProfiles/warnings/',
  notes: `${url}/notes/`,
  conditions: url + '/enumerables/conditions/',
  procedures: url + '/procedures/',
  mechanicVentilation: url + '/clinicTables/ventilationValues/',
  enumerables: url + '/enumerables/',
  external_enumerables: url + '/room-services/external-enumerables/',
  vitalSignsTypes: url + '/clinicTables/vitalSignTypes/',
  calculationsTypes: url + '/clinicTables/calculationTypes/',
  symtompsTypes: url + '/clinicTables/symptomTypes/',
  inmmunizationTypes: url + '/clinicTables/immunizationTypes/',
  encounterDiets: url + '/enumerables/encounterDiets/',
  encounterSpecialCourtesies: url + '/enumerables/encounterSpecialCourtesies/',
  encounterAdmitSources: url + '/enumerables/encounterAdminSources/',
  encounterDischarges: url + '/enumerables/encounterDischarges/',
  urgencyLevels: url + '/enumerables/urgencyLevels/',
  observationPerformers: url + '/enumerables/observationPerformers/',
  observationInterpretations: url + '/enumerables/observationInterpretations/',
  observationCategories: url + '/enumerables/observationCategories/',
  observations: url + '/observations/',
  immunizationOrigins: url + '/enumerables/immunizationOrigins/',
  immunizationRoutes: url + '/enumerables/immunizationRoutes/',
  underPoweredReason: url + '/enumerables/immunizationSubponentReasons/',
  customReportVariables: url + '/enumerables/customReportVariables/',
  statusReason: url + '/enumerables/medicationRequestStatus/',
  medicatioRequest: url + '/medicationRequests/',
  compoundUnits: url + '/enumerables/compoundUnits/',
  requestPriorities: url + '/enumerables/requestPriorities/',
  medicationRequestCategories: url + '/enumerables/medicationRequestCategories/',
  medicationAdministration: url + '/medicationAdministrations/',
  medicationAdminNotGivenCodes: url + '/enumerables/medicationAdminNotGivenCodes/',
  medicationAdminReasonCodes: url + '/enumerables/medicationAdminReasonCodes/',
  medicationAdminStatus: url + '/enumerables/medicationAdminStatus/',
  routeCodes: url + '/enumerables/routeCodes/',
  medicationMethodCodes: url + '/enumerables/medicationMethodCodes/',
  clinicalSettings: url + '/clinicalSettings/',
  sessionExpirationTime: 15,
  mailApi: url + '/mailer/',
  patientConsent: url + '/consents/',
  consentType: url + '/consentTypes/',
  consentVariablesList: url + '/enumerables/consentVariables/',
  consentScopeList: url + '/enumerables/consentscopes/',
  activityTypes: url + '/clinicTables/activityTypes/',
  hydricBalanceTypes: url + '/clinicTables/hydricBalanceTypes/',
  bodyMeasurementTypes: url + '/clinicTables/bodyMeasurementTypes/',
  medicalOrders: url + '/medicalOrders/',
  memberships: url + '/memberships/',
  esHelpUrl: 'ayuda.pegasimed.com/',
  enHelpUr: 'help.pegasimed.com/',
  operationalStatus: url + '/enumerables/operationalStatus/',
  biomarkerStydyType: url + '/clinicTables/biomarkerStudyTypes/',
  locationLogs: url + '/schedules/locationLogs/',
  biomarkerStudies: url + '/paraclinicalExams/biomarkerStudies/',
  linearReports: url + '/linearReports/',
  callHistory: url + '/video-calls/',
  callDetail: url + '/video-calls/details/',
  tokenDecode: url + '/room-services/external-schedules/tokens/'
};
